import superagent from 'superagent';
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {normalize, schema} from 'normalizr';

export const fetchSpecsheet = createAsyncThunk(
	'specsheet/get',
	(options, {getState}) =>
		superagent
			.get(`${getState().status.specsheetUrl}/int/${getState().status.lang}/specsheets.json`)
			.then((response) => JSON.parse(response.text))
			.catch((error) => error)
);

const specsheetInitialState = {
	status: 'idle',
	data: {
		specsheets: [],
	},
	error: {},
};
export const specsheetSlice = createSlice({
	name: 'specsheet',
	initialState: specsheetInitialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(fetchSpecsheet.fulfilled, (state, action) => {
			state.data.specsheets = action.payload;
			state.status = 'idle';
			state.error = {};
		});
	}
});


export const {} = specsheetSlice.actions;


export default specsheetSlice.reducer;
